<template>
  <div class="recommend-gift">
      <div class="flex shadow-btn slideBright" v-if="showActivity" @click="$router.push('/recommendGift')">
        <svg-icon class-name="gift" icon-class="gift" />
        推荐有礼
      </div>
    </div>
</template>
<script>
import activityApi from '@/api/member/activity'
export default {
  data() {
    return {
      memberInfo: {},
      showActivity: false,
    }
  },
  computed: {

  },
  mounted() {
    /*this.$store.dispatch('GetMemberInfo').then(res => {
      this.memberInfo = res || {}
    })*/
    this.checkActivity()
  },
  methods: {

    async checkActivity() {
      const isOldEnt = await this.checkEnt();
      const hasActivity = await  this.getActivities();
      if(isOldEnt && hasActivity){
        this.showActivity = true
      }
    },
    checkEnt(){
      return activityApi.checkOldEnt().then(res => {
        return res
      })
    },
    getActivities() {
      //判断当前是否有推荐活动进行中
      return activityApi.getProcessingActivityList().then(res => {
        //进行中的活动是否包括推荐有礼(老带新活动)
        if(res &&
          res.some(item =>
            item.type == 'ACTIVATING_CAMPAIGN' && item.scene == '3'
            && item.status == '1'
          ))
          return true
      })
    }
  },
}
</script>
<style scoped lang="scss">
.recommend-gift {
  height: 100%;
  display: flex;
  align-items: center;
}

@keyframes slideBright {
  0% {
    left: 0;
  }

  30% {
    left: 100%;
  }

  100% {
    left: 100%;
  }
}

.slideBright {
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 15px;
    height: 100%;
    transform: rotate(-45deg);
    background: linear-gradient(to right, transparent, #fff, transparent);
    animation: slideBright 3s ease-in-out infinite;
  }
}

.shadow-btn {
  color: red;
  border-radius: 5px;
  font-weight: bold;
  font-size: 12px;
  height: 70%;
  cursor: pointer;
  padding: 0 10px;
  justify-content: space-between;

  // &:hover {
  //   box-shadow: 0px 0px 3px rgba(255, 0, 0, 0.657);
  // }
}

.flex {
  display: flex;
  align-items: center;
  gap: 5px;
}

.gift {}
</style>

